import { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@evertrue/et-components';
import { getMomentObjectInTimezone } from 'base/new-utils';

const OutreachDraftCard = ({ draft, selectedDrafts, setSelectedDrafts }) => {
  const { id, email_recipients, subject, created_at, parsed_body, email_template_id, thankview_videos } = draft;
  const [selectedDraft, setSelectedDraft] = useState(false);

  const handleCheckboxChange = () => {
    setSelectedDraft((prevSelectedDraft) => {
      const newSelectedDraft = !prevSelectedDraft;
      if (newSelectedDraft) {
        setSelectedDrafts([...selectedDrafts, id]);
      } else {
        setSelectedDrafts(selectedDrafts.filter((draftId) => draftId !== id));
      }
      return newSelectedDraft;
    });
  };

  const recipientNames =
    email_recipients?.length > 0 ? email_recipients.map((recipient) => recipient.email_address).join(', ') : '';

  return (
    <div className="outreach-draft-card">
      <Checkbox
        className="outreach--checkbox-small"
        checked={selectedDraft}
        label="select"
        onChange={handleCheckboxChange}
      />
      <div>
        <div style={{ display: 'flex' }} key={id}>
          <div className="outreach--draft-card--header">
            <p className="outreach-draft-recipient-name">{recipientNames}</p>
            <strong>
              <p>{subject}</p>
            </strong>
          </div>
          <div className="outreach-draft-date-container">
            <p>{getMomentObjectInTimezone(created_at * 1000)?.format('dddd, MMM DD, YYYY')}</p>
          </div>
        </div>
        <div style={{ marginBottom: 0 }} className="outreach-draft-card-body">
          <p>{parsed_body}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="draft-card-tab-group">
            {thankview_videos?.length > 0 && (
              <>
                <div className="draft-card-tab-group--item outreach-custom-signal-video">
                  <span className="tab-text">
                    <i
                      role="img"
                      aria-label="icon: signal-video"
                      className="gt2-icon gt2-icon-signal-video base-nav-sub-item--icon gt-icon-fw draft-card-tab-group-icon-video"
                      alt="signal-video"
                      aria-hidden="true"
                    ></i>
                    &nbsp; Signal Video
                  </span>
                </div>
                <span className="draft-card-tab-group-border"> | </span>
              </>
            )}
            {email_template_id && (
              <div className="draft-card-tab-group--item">
                <span className="tab-text">
                  <strong>Template</strong>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

OutreachDraftCard.propTypes = {
  draft: PropTypes.object.isRequired,
  setSelectedDrafts: PropTypes.func,
  selectedDrafts: PropTypes.array,
};

export default OutreachDraftCard;
